module.exports = __webpack_public_path__ + "static/media/reply.0a0b76f1.svg";